import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";

type AppProps = {
  menuDetails: any;
  handleEditMenuDetails: (data: any) => void;
  headers: TableHeadersType[];
  isEditMenuListPresent: boolean;
};
const NormalTable = ({
  menuDetails,
  handleEditMenuDetails,
  headers,
  isEditMenuListPresent
}: AppProps) => {

 
  const renderTableData = () => {

    return (
      <tr>
        {headers?.length &&
          headers?.map((header: TableHeadersType) => {
            if (header.value === "menu_name") {
              return (
                <td>
                  <span>{menuDetails?.menu_name}</span>
                </td>
              );
            } 
            else if (header.value === "parent_name") {
              return (
                <td className="text-center">
                </td>
              );
            }
          })}
        <td style={{ width: "80px", textAlign: "center" }}>
         {isEditMenuListPresent && <span
            className="d-inline-block pointer"
          >
            <div
              style={{
                color: "#d43",
                fontSize: 20,
              }}
              onClick={() => handleEditMenuDetails(menuDetails)}
            >
              <i className="fas fa-pen"></i>
            </div>
          </span>}
        </td>
      </tr>
    );
  };
  return <>{renderTableData()}</>;
};
export default NormalTable;
